import { useNavigate } from "react-router-dom";
import "./screen.css";
import "./styles.css";
import "./EditUser.css"; // Add this new CSS file for styles
import { useEffect, useState } from "react";

function Sidebar() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      // style={{
      //   width: "240px",
      //   background: "linear-gradient(135deg, #8ec5fc, #8ec5fc)",
      //   color: "#332D56",
      //   display: "flex",
      //   flexDirection: "column",
      //   padding: "0px 0px",
      //   boxShadow: "4px 0 10px rgba(0,0,0,0.1)",
      // }}
      style={{
        position: isMobile ? "fixed" : "relative",
        top: 0,
        left: 0,
        height: "100vh",
        width: isMobile ? "70%" : "240px",
        background: "linear-gradient(135deg, #8ec5fc, #8ec5fc)",
        color: "#332D56",
        display: "flex",
        flexDirection: "column",
        padding: isMobile ? "10px" : "0px",
        boxShadow: "4px 0 10px rgba(0,0,0,0.1)",
        zIndex: 999, // must be > overlay
        transition: "width 0.3s ease-in-out", // Smooth transition for width on mobile
      }}
    >
      <div
        style={{
          marginBottom: 0,
          textAlign: "center",
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            fontSize: "100%",
            fontWeight: "bold",
            marginBottom: 0,
            marginTop: 0,
          }}
        >
          <img
            src={require("../img/logo1.png")}
            alt="logo"
            style={{ width: 90 }}
          />
        </div>
      </div>
      {[
        {
          label: "Dashboard",
          icon: require("../img/dashboard.png"),
          route: "/dashboard",
          isActive: false,
        },
        ...(localStorage.getItem("role") === "Product Manager"
          ? [
              {
                label: "Product Managers",
                icon: require("../img/leader.png"),
                route: "/alluser",
                isActive: false,
              },
            ]
          : []),
        ...(localStorage.getItem("role") === "Product Manager" ||
        localStorage.getItem("role") === "Site Manager"
          ? [
              {
                label: "Site Managers",
                icon: require("../img/site-manager.png"),
                route: "/alluser",
                isActive: false,
              },
            ]
          : []),

        ...(localStorage.getItem("role") === "Product Manager" ||
        localStorage.getItem("role") === "Site Manager"
          ? [
              {
                label: "Technicians",
                icon: require("../img/labor.png"),
                route: "/alluser",
                isActive: false,
              },
            ]
          : []),
        ...(localStorage.getItem("role") !== "User"
          ? [
              {
                label: "Users",
                icon: require("../img/people1.png"),
                route: "/alluser",
                isActive: false,
              },
            ]
          : []),

        {
          label: "Devices",
          icon: require("../img/settings.png"),
          route: "/mac",
          isActive: false,
        },
        ...(localStorage.getItem("role") === "Product Manager" ||
        localStorage.getItem("role") === "Site Manager"
          ? [
              {
                label: "Add",
                icon: require("../img/add.png"),
                route: "/adduser",
                isActive: true,
              },
            ]
          : []),

        {
          label: "Logout",
          icon: require("../img/logout.png"),
          route: "/",
          isActive: false,
        },
      ].map((item, index) => (
        <div
          key={index}
          onClick={() => {
            if (item?.label === "Logout") {
              navigate(item.route);
              localStorage.removeItem("role");
              localStorage.removeItem("loginId");
            } else {
              navigate(item.route, {
                state: { role: item?.label },
              });
            }
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "12px 36px",
            marginBottom: 8,
            borderRadius: 8,
            cursor: "pointer",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "rgba(255,255,255,0.2)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          <img
            src={item.icon}
            alt={item.label}
            style={{
              width: 22, // filter: "brightness(0) invert(1)"
            }}
          />
          <span style={{ fontSize: "100%", fontWeight: "600" }}>
            {item.label}
          </span>
        </div>
      ))}
    </div>
  );
}
export default Sidebar;
